import { lazy } from 'react';
import { Loadable } from 'berry/components';

const OwnProfile = Loadable(lazy(() => import('pages/Users/OwnProfile')));

const CommonRoutes = [
    {
        path: '/profile',
        element: <OwnProfile />,
        title: 'Profile'
    }
];

export default CommonRoutes;
